import { render, staticRenderFns } from "./bahanbakar.vue?vue&type=template&id=596b0590"
import script from "./bahanbakar.vue?vue&type=script&lang=js"
export * from "./bahanbakar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports